// Team-related DTOs and types based on C# implementation

export interface NormalResponse {
  success: boolean;
  message: string;
  data?: unknown;
}

export interface TeamProfileResponse {
  success: boolean;
  message: string;
  data: {
    team_id: number;
    name: string;
    city: string;
    state: string;
    country: string;
    info: string;
    profile_image: string;
    cover_image: string;
    created_at: string;
    updated_at: string;
  };
}

export interface TeamData {
  success: boolean;
  message: string;
  data: Team[];
}

export interface Team {
  team_id: number;
  name: string;
  city: string;
  state: string;
  country: string;
  info: string;
  profile_image: string;
  cover_image: string;
  created_at: string;
  updated_at: string;
  coach_id: number;
  member_count?: number;
}

export interface ProfileResponse {
  success: boolean;
  message: string;
  data: {
    user_id: number;
    name: string;
    email: string;
    profile_image?: string;
    bio?: string;
    location?: string;
    created_at: string;
    updated_at: string;
  };
}

export interface ImageUploadResponse {
  status: number;
  msg: string;
  image_link: string;
}


export interface VideoUploadResponse {
  status: number;
  msg: string;
  video_link: string;
}

export enum UserConnectionStatus {
  Pending = 0,
  Accepted = 1,
  Declined = 2,
  Blocked = 3
}

export enum TeamMemberStatus {
  Pending = 0,
  Active = 1,
  Inactive = 2,
  Removed = 3
}

// Request interfaces
export interface CreateTeamRequest {
  coach_id: number;
  name: string;
  city: string;
  state: string;
  country: string;
  info: string;
  profile_image: string;
  cover_image: string;
}

export interface UpdateTeamRequest {
  coach_id: number;
  team_id: number;
  name: string;
  city: string;
  state: string;
  country: string;
  info: string;
  profile_image: string;
  cover_image: string;
}

export interface AddTeamMemberRequest {
  coach_id: number;
  team_id: number;
  user_ids: number[];
}

export interface FetchNotificationsRequest {
  user_id: number;
}

export interface ClearNotificationsRequest {
  user_id: number;
}

export interface FetchTeamPostsRequest {
  team_id: number;
  user_id: number;
  coach_id: number;
  page: number;
}

export interface GetCoachSwimmersRequest {
  coach_id: number;
  status: UserConnectionStatus;
}

export interface GetSwimmerCoachesRequest {
  swimmer_id: number;
  status: UserConnectionStatus;
}

export interface GetSwimmerTeamsRequest {
  user_id: number;
}

export interface GetCoachTeamsRequest {
  coach_id: number;
}

export interface UploadTeamImageRequest {
  image: Uint8Array;
  image_mode: string;
}

export interface AcceptConnectionRequest {
  user_id: number;
  coach_id?: number;
  friend_id?: number;
  team_id?: number;
  action: boolean; // true for accept, false for decline
}

export interface GetUserFriendSwimmersRequest {
  user_id: number;
  friend_status: UserConnectionStatus;
  team_id: number;
  team_status: TeamMemberStatus;
}

export interface InviteToTeamRequest {
  coach_id: number;
  user_id: number;
  team_id: number;
}

export interface SwimmerConnectRequest {
  user_id: number;
  friend_id: number;
}

export interface DeleteNotificationRequest {
  user_id: number;
  notif_id: number;
}

export interface GetTeamSwimmersRequest {
  team_id: number;
  status: TeamMemberStatus;
}

export interface DeleteTeamPostRequest {
  post_id: number;
  team_id: number;
  user_id: number;
}

export interface DeleteTeamRequest {
  team_id: number;
  coach_id: number;
}

export interface RemoveSwimmerFromTeamRequest {
  team_id: number;
  swimmer_id: number;
  coach_id: number;
}


export interface TeamPost {
  id: string;
  team_id: string;
  user_id: string;
  coach_id: string;
  created_at: string;
  text: string | null;
  photo: string | null;
  video: string | null;
}
